import React, {useEffect, useState} from 'react';
import Modal from "react-bootstrap/Modal";
import {FaBook, FaBookOpen, FaCheckCircle, FaClock, FaCoins, FaFilter, FaFlag, FaTasks, FaUser} from "react-icons/fa";
import Row from "react-bootstrap/Row";
import {Badge, Card, Col, Image, Table} from "react-bootstrap";
import {editAssignment} from "../../../http/bookAPI";
import { toast } from "react-toastify";
import SubmitComplaint from "../../assignmentpages/SubmitComplaint";
import {getRedirectUrlApi} from "../../../http/userAPI";
import {fetchFullInfoAssignmentAndBook} from "../../../http/bookAPI";
import { useCallback } from "react";
import {FaArrowPointer} from "react-icons/fa6";
import SimpleLogsViewerBA from "../../logs/SimpleLogsViewerBA";
import ProofImageCard from "../../common/ProofImageCard";
import ImageLightbox from "../../common/ImageLightbox";

const InfoAssUnderBookS4 = ({ show, handleClose, assignment, onClosed }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [assignmentData, setAssignmentData] = useState(assignment);
    const date = new Date(assignment.start_read_date * 60 * 1000);
    const [showComplaint, setShowComplaint] = useState(false);
    const [showMessageToReviewer, setShowMessageToReviewer] = useState(false);
    const [messageToReviewer, setMessageToReviewer] = useState(assignment?.comment_to_review || "");
    const [fullImage, setFullImage] = useState(null);

// ---- helpers: "minutes since epoch" -> formatted ----

// минуты -> миллисекунды (безопасно)
    const minutesToMs = (m) => (Number.isFinite(m) ? m * 60 * 1000 : NaN);

// 1) Длинная дата + короткое время. По умолчанию en-GB (24h).
// Для AM/PM можно вызвать с { locale: 'en-US' }.
    const formatDateLongFromMinutes = (
        minutes,
        {
            locale = 'en-GB',
            timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
        } = {}
    ) => {
        const ms = minutesToMs(minutes);
        if (!Number.isFinite(ms)) return 'N/A';
        const d = new Date(ms);
        try {
            return new Intl.DateTimeFormat(locale, {
                dateStyle: 'long',  // e.g. "12 June 2025"
                timeStyle: 'short', // e.g. "22:15"
                timeZone,
            }).format(d);
        } catch {
            return d.toLocaleString(locale, { timeZone });
        }
    };

// 2) Длительность между двумя моментами (в минутах) => "Xd, YH, ZM"
    const formatDurationBetweenMinutes = (
        startMinutes,
        endMinutes = Math.floor(Date.now() / (60 * 1000))
    ) => {
        const s = minutesToMs(startMinutes);
        const e = minutesToMs(endMinutes);
        if (!Number.isFinite(s) || !Number.isFinite(e)) return 'N/A';

        const diffMs = Math.max(0, e - s);
        const totalMin = Math.floor(diffMs / (1000 * 60));
        const d = Math.floor(totalMin / (60 * 24));
        const h = Math.floor((totalMin % (60 * 24)) / 60);
        const m = totalMin % 60;
        return `${d}D, ${h}H, ${m}M`;
    };

// 3) Синоним: «сколько прошло с момента»
    const formatElapsedFromMinutes = (startMinutes) =>
        formatDurationBetweenMinutes(startMinutes);


    // ✅ Полные названия месяцев
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // ✅ Получаем дату начала чтения
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedHours = hours < 10 ? `0${hours}` : hours;

    // ✅ Вычисляем, сколько времени прошло с момента начала чтения
    const now = new Date();
    const elapsedTime = now - date;
    const elapsedMinutes = Math.floor(elapsedTime / (1000 * 60));
    const elapsedHours = Math.floor(elapsedMinutes / 60);
    const elapsedDays = Math.floor(elapsedHours / 24);

    const remainingHours = elapsedHours % 24;
    const remainingMinutes = elapsedMinutes % 60;

    const [showNotification, setShowNotification] = useState(false);

    useEffect(() => {
        if (show) setAssignmentData(assignment);
    }, [show, assignment?.id]);

    const refetchAssignment = useCallback(async () => {
        try {
            setLoading(true);
            const data = await fetchFullInfoAssignmentAndBook(assignment?.id);
            const next = data?.assignment ?? data;
            if (next) setAssignmentData(next);
        } catch (e) {
            console.error("Refetch assignment failed:", e);
            setError("Failed to refresh assignment data.");
        } finally {
            setLoading(false);
        }
    }, [assignment?.id]);

    const a = assignmentData ?? assignment;

    useEffect(() => {
        if (show) {
            setAssignmentData(assignment); // быстрый первый рендер
            refetchAssignment();           // подтягиваем свежее
        }
    }, [show, assignment?.id, refetchAssignment]);


    const handleCopy = () => {
        navigator.clipboard.writeText(assignment.review_link);
        setShowNotification(true);

        // ✅ Выводим тост об успешной проверке
        toast.success("The review link has been copied.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

        // Скрыть уведомление через 2 секунды
        setTimeout(() => {
            setShowNotification(false);
        }, 2000);
    };

    // Хелпер для фото: если пришло только имя файла — собираем URL как {API}/photo_proofs/{file}
    const buildPhotoUrl = (val) => {
        if (!val) return null;
        if (/^https?:\/\//i.test(val)) return val;
        return `${process.env.REACT_APP_API_URL}photo_proofs/${val}`;
    };

    const photo1 = buildPhotoUrl(a?.checked_review_photo);
    const photo2 = buildPhotoUrl(a?.checked_review_photo2);
    const proofUrls = [photo1, photo2].filter(Boolean);
    const proofFallback = `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;


    return (
        <Modal
            size="lg"
            show={show}
            onHide={() => {
                setError("");
                handleClose();
                if (typeof onClosed === "function") onClosed(); // 🔹 рефетч наверху
            }}
            top
        >
            <div className="modal-content">
                <div className="modal-header small" style={{height:40}}>
                    <h6 className="modal-title fs-6">Assignment: #{assignment?.bookId}-{assignment?.id}</h6>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => {
                            setError("");
                            handleClose();
                            if (typeof onClosed === "function") onClosed();
                        }}
                    ></button>
                </div>

                <div className="modal-body small me-3 ms-3 p-3">
                    <p
                        className="mb-2 fs-6 mt-0 text-muted"
                    >
                        <FaCheckCircle className="me-1 text-success" />

                        <span className="m-0 fw-semibold"> Confirmed! Bada-bum!</span>
                    </p>

                    {/* Posted */}
                    <Row className="g-2 row-cols-1 row-cols-md-2">
                        <Col>
                            <ul className="list-unstyled mb-0 small">
                                {a?.start_rev_date && (
                                    <li className="d-flex align-items-center lh-sm mb-1">
                                        <FaBook className="me-2" />
                                        <span className="text-muted">
            <span className="d-none d-md-inline">Posted: </span>
            <span className="d-inline d-md-none">Posted: </span>
            <strong className="ms-1">{formatDateLongFromMinutes(a.start_rev_date)}</strong>
          </span>
                                    </li>
                                )}

                                {a?.start_read_date && (
                                    <li className="d-flex align-items-center lh-sm mb-1">
                                        <FaBookOpen className="me-2" />
                                        <span className="text-muted">
            <span className="d-none d-md-inline">Start: </span>
            <span className="d-inline d-md-none">Start: </span>
            <strong className="ms-1">{formatDateLongFromMinutes(a.start_read_date)}</strong>
          </span>
                                    </li>
                                )}

                                {a?.publish_rev_date && (
                                    <li className="d-flex align-items-center lh-sm mb-1">
                                        <FaFlag className="me-2" />
                                        <span className="text-muted">
            <span className="d-none d-md-inline">Reported: </span>
            <span className="d-inline d-md-none">Reported: </span>
            <strong className="ms-1">{formatDateLongFromMinutes(a.publish_rev_date)}</strong>
          </span>
                                    </li>
                                )}

                                {a?.end_rev_date && (
                                    <li className="d-flex align-items-center lh-sm mb-1">
                                        <FaCheckCircle className="me-2 text-success" />
                                        <span className="text-muted">
            <span className="d-none d-md-inline">Confirmed: </span>
            <span className="d-inline d-md-none">Confirmed: </span>
            <strong className="ms-1">{formatDateLongFromMinutes(a.end_rev_date)}</strong>
          </span>
                                    </li>
                                )}

                                {a?.start_read_date && a?.end_rev_date && (
                                    <li className="d-flex align-items-center lh-sm mb-1">
                                        <FaClock className="me-2" />
                                        <span className="text-muted">
            <span className="d-none d-md-inline">Time: </span>
            <span className="d-inline d-md-none">Time: </span>
            <strong className="ms-1">
              {formatDurationBetweenMinutes(a.start_read_date, a.end_rev_date)}
            </strong>
          </span>
                                    </li>
                                )}
                                <li className="d-flex align-items-center lh-sm">
                                    <p className="me-2 mb-1 text-muted" style={{ lineHeight: "1.2" }}>
                                        <FaFilter className="me-2" />
                                        Country:
                                        <b>
                                            {(() => {
                                                switch (assignment.assignment_prefer_country) {
                                                    case "https://www.amazon.com":
                                                        return " USA";
                                                    case "https://www.amazon.ca":
                                                        return " Canada";
                                                    case "https://www.amazon.com.au":
                                                        return " Australia";
                                                    case "https://www.amazon.co.uk":
                                                        return " United Kingdom";
                                                    case "https://www.amazon.de":
                                                        return " Deutschland";
                                                    case "https://www.amazon.fr":
                                                        return " France";
                                                    case "https://www.amazon.it":
                                                        return " Italia";
                                                    case "https://www.amazon.es":
                                                        return " España";
                                                    case "https://www.amazon.in":
                                                        return " India";
                                                    case "https://www.amazon.co.jp":
                                                        return " Japan";
                                                    case "https://www.amazon.com.br":
                                                        return " Brasil";
                                                    case "https://www.amazon.nl":
                                                        return " Netherlands";
                                                    case "https://www.amazon.com.mx":
                                                        return " Mexico";
                                                    case "https://www.amazon.sg":
                                                        return " Singapore";
                                                    case "https://www.amazon.cn":
                                                        return " China";
                                                    default:
                                                        return " All";
                                                }
                                            })()}</b>
                                        {assignment?.rating_of_reviewer > 20 && (
                                            <span className="ms-0 fw-semibold text-success">
                                        {" "}/ Quality: {assignment.rating_of_reviewer}%
                                     </span>
                                        )}
                                    </p>
                                </li>
                            </ul>
                        </Col>

                        <Col>
                            <ul className="list-unstyled mb-0 small">
                                {a?.start_rev_date && a?.end_rev_date && (
                                    <li className="d-flex align-items-center lh-sm mb-1">
                                        <FaArrowPointer className="me-2" />
                                        <span className="text-muted">
            <span className="d-none d-md-inline">Time from Start to Finish: </span>
            <span className="d-inline d-md-none">Duration: </span>
            <strong className="ms-1">
              {formatDurationBetweenMinutes(a.start_rev_date, a.end_rev_date)}
            </strong>
          </span>
                                    </li>
                                )}

                                <li className="d-flex align-items-center lh-sm mb-1">
                                    <FaBook className="me-2" />
                                    <span className="text-muted text-truncate" style={{maxWidth: '100%'}}>
          Assignment for:
          <strong className="ms-1">
            {(() => {
                switch (a?.booksTypeId) {
                    case 1: return "Book in Kindle";
                    case 2: return "Book in Paperback";
                    case 3: return "Book in Hardcover";
                    case 4: return "Audiobook";
                    case 5: return "Boost Existing Review";
                    case 6: return "Report Existing Review";
                    case 7: return "Physical Product,";
                    case 8: return "Physical Product,";
                    case 9: return "Physical Product,";
                    case 10: return "Physical Product,";
                    default: return "N/A";
                }
            })()}
          </strong>
        </span>
                                </li>

                                <li className="d-flex align-items-center lh-sm mb-1">
                                    <FaTasks className="me-2" />
                                    <span className="text-muted text-truncate" style={{maxWidth: '100%'}}>
          Type:
          <strong className="ms-1">
            {(() => {
                switch (a?.assTypeId) {
                    case 1: return "Universal Assignment";
                    case 2: return "Kindle Unlimited";
                    case 3: return "Kindle Verified Purchase";
                    case 4: return "Kindle Verified Purchase + Img";
                    case 5: return "Kindle Verified Purchase Search&Buy";
                    case 6: return "Kindle Verified Search&Buy + Img";
                    case 7: return "Universal Assignment for Audio";
                    case 8: return "Audible Promo Code Assignment";
                    case 9: return "Verified Kindle Unlimited";
                    case 10: return "Paperback BuyOut";
                    case 11: return "Paperback Search&BuyOut";
                    case 12: return "Paperback Verified Purchase + Img";
                    case 13: return "Paperback Verified Purchase + Video";
                    case 14: return "HC BuyOut";
                    case 15: return "HC Search&BuyOut";
                    case 16: return "HC Verified Pur. + Img";
                    case 17: return "HC Verified + Video";
                    case 18: return "PB Verified Purchase";
                    case 19: return "PB Verified Purchase Search&Buy";
                    case 20: return "HC Verified Purchase";
                    case 21: return "HC Verified Purchase Search&Buy";
                    case 22: return "Product BuyOut";
                    case 23: return "Product Search&BuyOut";
                    case 24: return "Product Verified Purchase";
                    case 25: return "Product Verified + Img";
                    case 26: return "Product Verified + Vid";
                    case 27: return "Product VP Search&Buy";
                    case 28: return "Make Helpful Internal";
                    case 29: return "Write Report Internal";
                    case 30: return "Make Helpful External";
                    case 31: return "Write Report External";
                    case 32: return "Set Stars Rating";
                    default: return "Unknown Type";
                }
            })()}
          </strong>
        </span>
                                </li>

                                <li className="d-flex align-items-center lh-sm mb-1">
                                    <FaCoins className="me-2" />
                                    <span className="text-muted">
          Reward / Cost:
          <strong className="ms-1">{a?.assignment_price_publisher ?? "Unknown"}</strong> Virt /
          <b className="text-danger ms-1">
            {([10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(a?.assTypeId))
                ? (a?.assignment_price_publisher ? ` $${a?.book_cost_compensation}` : "N/A")
                : (() => {
                    let priceLabel;
                    switch (a?.booksPriceId) {
                        case 1: priceLabel = " Free"; break;
                        case 2: priceLabel = " $0.99"; break;
                        case 3: priceLabel = " $1.99"; break;
                        case 4: priceLabel = " $2.99"; break;
                        case 5: priceLabel = " $3.99"; break;
                        case 6: priceLabel = " $4.99"; break;
                        case 7: priceLabel = " $5.99"; break;
                        case 8: priceLabel = " $6.99"; break;
                        case 9: priceLabel = " $7.99"; break;
                        case 10: priceLabel = " $8.99"; break;
                        case 11: priceLabel = " $9.99"; break;
                        default: priceLabel = " Unknown Type";
                    }
                    if (a?.booksPriceId === 1 && [3,4,5,6,32].includes(a?.assTypeId)) {
                        priceLabel += " Promo";
                    }
                    return priceLabel;
                })()
            }
          </b>
        </span>
                                </li>

                                <li className="d-flex align-items-center lh-sm">
                                    <FaUser className="me-2" />
                                    <span className="text-muted text-truncate" style={{maxWidth: '100%'}}>
          Participant:
          <strong className="ms-1">"{a?.reviewer_name || "Unknown"}"</strong>
        </span>
                                </li>

                            </ul>
                        </Col>
                    </Row>





        {![10, 11, 14, 15, 22, 23, 28, 29, 30, 31, 32].includes(assignment?.assTypeId) && (<>
                    <span>

  <p
      className="me-2 mb-2 mt-1 fw-semibold text-muted"
      style={{ lineHeight: "1.7" }}
  >
    We have carefully reviewed the feedback left by "{a?.reviewer_name || "Unknown"}".
    You can find the verification results in the table below and check the review yourself by copying the provided link.
    You may also choose to submit a complaint or send a message to the reviewer — for example, to ask a question or request a small edit to the review.
  </p>
</span>

                    <Row className="d-flex justify-content-center mt-2">
                        <Col md={12} className="p-0">
                            <Row className="g-2 align-items-stretch">
                                {/* Левая карточка: таблица проверки */}
                                <Col md={8} className="d-flex">
                                    <div className="card border border-secondary mt-1 rounded w-100 text-start">
                                        <div className="card-header py-1 bg-light">Verification Results</div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive">
                                                <table className="table table-sm table-bordered mb-0 align-middle" style={{ lineHeight: "14px" }}>
                                                    <thead className="table-secondary">
                                                    <tr>
                                                        <th className="px-2 py-1 fw-normal" style={{ whiteSpace: "nowrap" }}>Field:</th>
                                                        <th className="px-2 py-1 fw-normal" style={{ whiteSpace: "nowrap" }}>Verification Result:</th>
                                                        <th className="px-2 py-1 fw-normal">Matched?</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td className="px-2 py-1 " style={{ whiteSpace: "nowrap" }}>
                                                            {a?.assTypeId === 8 ? "Overall Rating:" : "Rating:"}
                                                        </td>
                                                        <td className="px-2 py-1" style={{ whiteSpace: "nowrap" }}>
                                                            {[...Array(5)].map((_, index) => (
                                                                <i
                                                                    key={index}
                                                                    className={`bi bi-star${index < a?.checked_review_rating ? "-fill" : ""}`}
                                                                    style={{ color: index < a?.checked_review_rating ? "gold" : "lightgray", fontSize: "14px", marginRight: "5px" }}
                                                                />
                                                            ))}
                                                        </td>
                                                        <td className="px-2 py-1"><span className="text-success ">✅ Matched</span></td>
                                                    </tr>

                                                    {a?.assTypeId === 8 && (
                                                        <>
                                                            <tr className="table-light">
                                                                <td className="px-2 py-1 " style={{ whiteSpace: "nowrap" }}>Performance Rating:</td>
                                                                <td className="px-2 py-1" style={{ whiteSpace: "nowrap" }}>
                                                                    {[...Array(5)].map((_, index) => (
                                                                        <i
                                                                            key={index}
                                                                            className={`bi bi-star${index < a?.checked_performance_rating ? "-fill" : ""}`}
                                                                            style={{ color: index < a?.checked_performance_rating ? "gold" : "lightgray", fontSize: "18px", marginRight: "6px" }}
                                                                        />
                                                                    ))}
                                                                </td>
                                                                <td className="px-2 py-1"><span className="text-success ">✅ Just Info</span></td>
                                                            </tr>

                                                            <tr>
                                                                <td className="px-2 py-1 " style={{ whiteSpace: "nowrap" }}>Story Rating:</td>
                                                                <td className="px-2 py-1" style={{ whiteSpace: "nowrap" }}>
                                                                    {[...Array(5)].map((_, index) => (
                                                                        <i
                                                                            key={index}
                                                                            className={`bi bi-star${index < a?.checked_story_rating ? "-fill" : ""}`}
                                                                            style={{ color: index < a?.checked_story_rating ? "gold" : "lightgray", fontSize: "18px", marginRight: "6px" }}
                                                                        />
                                                                    ))}
                                                                </td>
                                                                <td className="px-2 py-1"><span className="text-success ">✅ Just Info</span></td>
                                                            </tr>
                                                        </>
                                                    )}

                                                    <tr className="table-light">
                                                        <td className="px-2 py-1 " style={{ whiteSpace: "nowrap" }}>Reviewer:</td>
                                                        <td className="px-2 py-1" style={{ whiteSpace: "nowrap" }}>
                                                            <span className="text-success ">{a?.checked_review_name}</span>
                                                        </td>
                                                        <td className="px-2 py-1"><span className="text-success ">✅ Matched</span></td>
                                                    </tr>

                                                    <tr>
                                                        <td className="px-2 py-1 ">ASIN:</td>
                                                        <td className="px-2 py-1" style={{ whiteSpace: "nowrap" }}>
                                                            <span className="text-success ">{a?.checked_asin}</span>
                                                        </td>
                                                        <td className="px-2 py-1"><span className="text-success ">✅ Matched</span></td>
                                                    </tr>

                                                    {[3,4,5,6,9,10,11,12,13,14,15,16,17].includes(a?.assTypeId) && (
                                                        <tr className="table-light">
                                                            <td className="px-2 py-1" style={{ whiteSpace: "nowrap" }}>Verified Purchase:</td>
                                                            <td className="px-2 py-1" style={{ whiteSpace: "nowrap" }}>
                                                                <span className="text-success ">{a?.checked_review_status || "Not Verified Purchase"}</span>
                                                            </td>
                                                            <td className="px-2 py-1" style={{ whiteSpace: "nowrap" }}>
                                                               <span className="text-success "> {a?.checked_review_status ? "✅ Matched" : "❌ Not Matched"}</span>
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {[4,6,10,11,12,13,14,15,16,17].includes(a?.assTypeId) && (
                                                        <tr>
                                                            <td className="px-2 py-1 " style={{ whiteSpace: "nowrap" }}>Photo in Review:</td>
                                                            <td className="px-2 py-1" style={{ whiteSpace: "nowrap" }}>
                                                                <span className="text-success ">{a?.checked_review_photo || "No Photo"}</span>
                                                            </td>
                                                            <td className="px-2 py-1" style={{ whiteSpace: "nowrap" }}>
                                                                {a?.checked_review_photo ? "✅ Matched" : "❌ Not Matched"}
                                                            </td>
                                                        </tr>
                                                    )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Правая карточка: действия */}
                                <Col md={4} className="d-flex">
                                    <div className="card border border-secondary mt-1  rounded w-100 text-start">
                                        <div className="card-header py-1 bg-light">Actions</div>
                                        <div className="card-body d-grid gap-2">
                                            {a?.assignment_status === 'SUCCESS' && (
                                                <button
                                                    className={`btn btn-sm ${showNotification ? 'btn-info' : 'btn-outline-success'} w-100`}
                                                    onClick={handleCopy}
                                                >
                                                    <i className="bi bi-link-45deg me-2"></i>
                                                    {showNotification ? 'Review Link Copied' : 'Copy Review Link'}
                                                </button>
                                            )}

                                            {a?.assignment_status === 'SUCCESS' && (
                                                <button
                                                    className="btn btn-sm btn-outline-danger w-100"
                                                    onClick={() => {
                                                        setShowComplaint(v => !v);
                                                        setShowMessageToReviewer(false);
                                                    }}
                                                    disabled={a?.check_status !== 'COMPLETE'}
                                                >
                                                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                                    {a?.check_status === 'COMPLAINT'
                                                        ? 'Working On'
                                                        : a?.check_status === 'REFUNDED'
                                                            ? 'Refunded'
                                                            : a?.check_status === 'DECLINED'
                                                                ? 'Declined'
                                                                : 'Submit Complaint'}
                                                </button>
                                            )}



                                            {a?.assignment_status === 'SUCCESS' && (
                                                <button
                                                    className="btn btn-sm btn-outline-success w-100"
                                                    onClick={() => {
                                                        setShowMessageToReviewer(v => !v);
                                                        setShowComplaint(false);
                                                    }}
                                                >
                                                    <i className="bi bi-envelope-fill me-2"></i>
                                                    Write to Reviewer
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>



                    {/* 🔹 Карточка "Message to Reviewer" */}
                    {showMessageToReviewer && (
                        <Row className="d-flex justify-content-center mt-3">
                            <Col md={12} className="p-0 text-start">
                                <div className="card border border-secondary   rounded">
                                    <div className="card-header py-1">
                                        Message to Reviewer
                                    </div>
                                    <div className="card-body p-3">
                                        <p className="text-muted mb-2" style={{ lineHeight: "1.3" }}>
                                            Kindly write a short message to the reviewer. Please be specific and polite. This message will be visible to the reviewer.
                                        </p>

                                        <textarea
                                            className="form-control form-control-sm border border-secondary"
                                            rows={3}
                                            value={messageToReviewer}
                                            onChange={(e) => setMessageToReviewer(e.target.value)}
                                            placeholder="Enter your message to the reviewer..."
                                        />

                                        <div className="d-flex justify-content-end gap-2 mt-3">
                                            <button
                                                className="btn btn-sm btn-secondary"
                                                onClick={() => setShowMessageToReviewer(false)}
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                className="btn btn-sm btn-success"
                                                onClick={async () => {
                                                    try {
                                                        if (!a?.id) return;
                                                        await editAssignment({
                                                            id: a.id,
                                                            comment_to_review: messageToReviewer || "",
                                                        });
                                                        toast.success("Message sent to the reviewer.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                                                        await refetchAssignment();
                                                        setShowMessageToReviewer(false);
                                                    } catch (err) {
                                                        console.error(err);
                                                        toast.error("Failed to send message.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                                                    }
                                                }}
                                            >
                                                Send Message
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}


                    {showComplaint && a?.check_status === 'COMPLETE' && (<>
                        <Row className="d-flex justify-content-center mt-3">
                            <Col md={12} className="p-0   rounded text-start">
                                <SubmitComplaint
                                    assignmentId={a?.id}
                                    staffMessage={a?.staff_comment}
                                    end_rev_date={a?.end_rev_date}
                                    defaultReason={`I have an issue with the review by "${a?.reviewer_name || "Unknown"}" on ASIN ${a?.checked_asin || "N/A"}.`}
                                    onSubmitted={async (res) => {
                                        toast.success(res?.message || "Complaint submitted.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                                        await refetchAssignment();
                                        setShowComplaint(false);
                                    }}
                                />
                            </Col>
                        </Row>
                    </>)}

                    {(() => {
                        const cs = String(a?.check_status || "").toUpperCase();

                        // REFUNDED — зелёная "успех" карточка
                        if (cs === "REFUNDED") {
                            return (
                                <Row className="d-flex justify-content-center mt-3">
                                    <Col md={12} className="p-0 text-start">
                                        <div className="card border border-success   rounded" aria-live="polite">
                                            <div className="card-body p-3">
                                                <h6 className="fs-6 mb-2 text-success d-flex align-items-center">
                                                    <i className="bi bi-check-circle-fill me-2"></i>
                                                    Assignment Refunded
                                                </h6>
                                                <div className="mb-1">
                                                    Your complaint was approved. The assignment was rolled back and funds were refunded to your balance.
                                                </div>

                                                {/* Доп. детали, если есть */}
                                                <div className="text-muted">
                                                    {typeof a?.assignment_price_publisher !== "undefined" && (
                                                        <>
                                                            <span className="fw-semibold">Refunded:</span> {a.assignment_price_publisher} Virt{" "}
                                                        </>
                                                    )}
                                                    {a?.complaint_flow?.trim() && (
                                                        <>
                                                            <span className="fw-semibold ms-2">Flow:</span> {a.complaint_flow}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            );
                        }

                        // COMPLAINT — информкарточка (в процессе)
                        if (cs === "COMPLAINT") {
                            return (
                                <Row className="d-flex justify-content-center mt-3">
                                    <Col md={12} className="p-0 text-start">
                                        <div className="card border border-danger   rounded" aria-live="polite">
                                            <div className="card-body p-3">
                                                <h6 className="fs-6 mb-2 text-danger d-flex align-items-center">
                                                    <i className="bi bi-hourglass-split me-2"></i>
                                                    Complaint In Progress
                                                </h6>
                                                <div className="mb-1">
                                                    Your complaint has been received and is currently under review. We’ll notify you once a decision is made.
                                                </div>

                                                {a?.complaint_flow?.trim() && (
                                                    <div className="small text-muted">
                                                        <span className="fw-semibold">Flow:</span> {a.complaint_flow}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            );
                        }

                        // DECLINED — красная карточка (жалоба отклонена)
                        if (cs === "DECLINED") {
                            return (
                                <Row className="d-flex justify-content-center mt-3">
                                    <Col md={12} className="p-0 text-start">
                                        <div className="card border border-danger   rounded" aria-live="polite">
                                            <div className="card-body p-3">
                                                <h6 className="fs-6 mb-2 text-danger d-flex align-items-center">
                                                    <i className="bi bi-x-circle-fill me-2"></i>
                                                    Complaint Declined
                                                </h6>
                                                <div className=" mb-1">
                                                    After review, your complaint was declined. Please see the explanation below.
                                                </div>

                                                {a?.complaint_flow?.trim() && (
                                                    <div className=" text-muted">
                                                        <span className="fw-semibold">Reason:</span> {a.complaint_flow}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            );
                        }

                        return null;
                    })()}

                    {a?.why_not_5_text && (
                        <Row className="d-flex justify-content-center mt-3">
                            <Col
                                md={12}
                                className="border border-secondary p-3 rounded bg-light text-start"
                            >
                                <p className="text-dark text-muted mb-2" style={{ lineHeight: "1.4" }}>
                                    <FaUser className="me-1 fa-shake text-success" />
                                    The reader "{a?.reviewer_name || "Unknown"}" has sent you a message to
                                    help improve your book. Rating{" "}
                                    {a?.rating || "Unknown"}.0 stars because:
                                </p>

                                <span className="text-danger fw-semibold d-block mb-2">
        {a?.why_not_5_text || "No"}
      </span>

                                <p className="text-dark text-muted mb-0" style={{ lineHeight: "1.4" }}>
                                    You may not agree with this rating, but it is important to take the
                                    reader's comment into consideration and take appropriate action.
                                </p>
                            </Col>
                        </Row>
                    )}
                    {![28, 29, 30, 31, 32].includes(assignment?.assTypeId) && (
                    <Row className="d-flex justify-content-center mt-3">
                        <Col md={12} className="p-0   rounded text-start">
                    <Card className="border-secondary">
                        <Card.Header className="py-1">After Review check we found such data:</Card.Header>
                        <Card.Body className="p-3">
                            <Row className=" mb-1">
                                <Col>
                                    <strong className="text-muted"></strong>
                                   </Col>
                            </Row>
                            <div className="table-responsive">
                                <table className="table table-sm table-bordered   rounded mb-0" style={{ lineHeight: "14px" }}>
                                    <thead className="table-secondary d-none d-md-table-header-group">
                                    <tr>
                                        <th className="px-2 py-1">Reviewer</th>
                                        <th className="px-2 py-1">Date</th>
                                        <th className="px-2 py-1">Country</th>
                                        <th className="px-2 py-1">ASIN</th>
                                        <th className="px-2 py-1">Type</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr className="d-block d-md-table-row border mb-2 rounded">
                                        <td className="d-flex d-md-table-cell justify-content-between px-2 py-1 border">
                                            <span className="fw-semibold d-md-none text-muted">Reviewer:</span>
                                            <span>{a?.checked_review_name || "No Name"}</span>
                                        </td>
                                        <td className="d-flex d-md-table-cell justify-content-between px-2 py-1 border">
                                            <span className="fw-semibold d-md-none text-muted">Date:</span>
                                            <span>{a?.checked_review_date || "No Date"}</span>
                                        </td>
                                        <td className="d-flex d-md-table-cell justify-content-between px-2 py-1 border">
                                            <span className="fw-semibold d-md-none text-muted">Country:</span>
                                            <span>{a?.checked_review_country || "No Country"}</span>
                                        </td>
                                        <td className="d-flex d-md-table-cell justify-content-between px-2 py-1 border">
                                            <span className="fw-semibold d-md-none text-muted">ASIN:</span>
                                            <span>{a?.checked_asin || "No ASIN"}</span>
                                        </td>
                                        <td className="d-flex d-md-table-cell justify-content-between px-2 py-1 border">
                                            <span className="fw-semibold d-md-none text-muted">Type:</span>
                                            <span>{a?.assTypeId === 8 ? "Audible Review" : (a?.checked_review_status || "Unverified Purchase")}</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <Row className=" mt-2">
                                <Col>
                                    <strong className="text-muted mt-2">Title of Review:</strong>
                                    <p className="me-2 mb-1 mt-0 fst-italic text-muted" style={{ lineHeight: "1" }}>
                                        {a?.checked_review_title || "No Title"}</p>
                                </Col>
                            </Row>




                            <strong className="text-muted">Text of Review: </strong>
                            <p className="text-dark text-muted fst-italic small" style={{ lineHeight: "1.2" }}>{a?.checked_review_text || "No Text"}
                                <br />
                           </p>
                            {a?.checked_review_photo && (
                                <>
                                    {(() => {
                                        const isVideoUrl = (u = "") =>
                                            /\.mp4(\?|$)/i.test(u) || u.includes("/vse-vms-transcoding-artifact-");

                                        const PHOTO_ONLY_TYPES = new Set([18, 19, 20, 21]);
                                        const assType = Number(a?.assTypeId ?? assignment?.assTypeId);
                                        const imgWidth = PHOTO_ONLY_TYPES.has(assType) ? 350 : 115;

                                        let urls;
                                        if (PHOTO_ONLY_TYPES.has(assType)) {
                                            const photo1 = buildPhotoUrl(a?.checked_review_photo ?? assignment?.checked_review_photo);
                                            const photo2 = buildPhotoUrl(a?.checked_review_photo2 ?? assignment?.checked_review_photo2);
                                            urls = [photo1, photo2].filter(Boolean);
                                        } else {
                                            urls = [
                                                a?.checked_review_photo,
                                                a?.checked_review_photo2,
                                                a?.checked_review_photo3,
                                                a?.checked_review_photo4,
                                                a?.checked_review_photo5,
                                            ].filter(Boolean).slice(0, 5);
                                        }

                                        if (!urls.length) return null;

                                        const fallback = `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;

                                        return (<>
                                                <strong className="text-muted mt-0 me-2">
                                                    {PHOTO_ONLY_TYPES.has(assType)
                                                        ? "Receipt and photos provided by the reviewer:"
                                                        : "Media in Review:"}
                                                </strong>
                                                <div
                                                    className="d-flex align-items-center justify-content-start flex-nowrap overflow-auto mt-2 mb-2"
                                                    style={{ gap: 8 }}
                                                >
                                                    {urls.map((url, idx) =>
                                                        isVideoUrl(url) ? (
                                                            <video
                                                                key={`media-${idx}`}
                                                                src={url}
                                                                preload="metadata"
                                                                controls
                                                                className="shadow rounded"
                                                                style={{ width: 200, borderRadius: 6, objectFit: "cover" }}
                                                                onError={(e) => {
                                                                    e.currentTarget.outerHTML = `
                  <img 
                    src="${fallback}" 
                    style="width:120px; height:120px; object-fit:cover; border-radius:6px" 
                    class="shadow"
                    alt="Fallback"
                  />
                `;
                                                                }}
                                                            />
                                                        ) : (
                                                            <Image
                                                                key={`media-${idx}`}
                                                                src={url}
                                                                alt={`Review Media ${idx + 1}`}
                                                                className="border border-secondary"
                                                                style={{ width: imgWidth, objectFit: "cover", borderRadius: 6, cursor: "zoom-in" }}
                                                                onError={(e) => {
                                                                    e.currentTarget.onerror = null;
                                                                    e.currentTarget.src = fallback;
                                                                }}
                                                                onClick={() => setFullImage(url)}
                                                            />
                                                        )
                                                    )}
                                                </div>
                                            </>
                                        );
                                    })()}
                                </>
                            )}
                            <strong className="text-muted mb-0">Review Link: </strong>
                            <p className="mt-0 mb-0 text-muted">
                                {/* Desktop / Tablet */}
                                <span
                                    className="text-primary small text-break d-none d-md-inline"
                                    role="button"
                                    onClick={async () => {
                                        try {
                                            const targetUrl = a?.review_link;
                                            if (!targetUrl) return;

                                            const response = await getRedirectUrlApi(targetUrl);

                                            if (response && response.redirectUrl) {
                                                window.open(response.redirectUrl, "_blank", "noopener,noreferrer");
                                            } else {
                                                console.error("Failed to get redirect URL");
                                            }
                                        } catch (err) {
                                            console.error("Redirect error:", err);
                                        }
                                    }}
                                >
    <strong>{a?.review_link}</strong>
  </span>

                                {/* Mobile */}
                                <span
                                    className="text-primary small d-inline d-md-none"
                                    role="button"
                                    onClick={async () => {
                                        try {
                                            const targetUrl = a?.review_link;
                                            if (!targetUrl) return;

                                            const response = await getRedirectUrlApi(targetUrl);

                                            if (response && response.redirectUrl) {
                                                window.open(response.redirectUrl, "_blank", "noopener,noreferrer");
                                            } else {
                                                console.error("Failed to get redirect URL");
                                            }
                                        } catch (err) {
                                            console.error("Redirect error:", err);
                                        }
                                    }}
                                >
    <strong>Check Review</strong>
  </span>
                            </p>
                        </Card.Body>
                    </Card>
                        </Col>
                    </Row>
                        )}
     </>)}

        {[10, 11, 14, 15].includes(assignment?.assTypeId) && (<>
            {/* Две фото из БД */}
            {(photo1 || photo2) && (
                <>
                    <h6 className="text-muted mt-2 me-2">Purchase proofs were uploaded by the reviewer and verified as real by our staff.</h6>
                    <p>This type of assignment involves a one-time verification by our team and does not include a public review, rebates, or complaints.
                        If you have any doubts regarding the authenticity of the submitted photos, please contact our support team for further assistance.</p>
                    <div
                        className="mt-2"
                        style={{
                            display: "grid",
                            gridTemplateColumns: proofUrls.length > 1 ? "repeat(2, minmax(0, 1fr))" : "minmax(0, 50%)",
                            justifyContent: "start",
                            gap: 12,
                            width: "100%",
                        }}
                    >
                        {proofUrls.map((url, idx) => (
                            <ProofImageCard
                                key={`proof-${idx}`}
                                src={url}
                                alt={`Proof ${idx + 1}`}
                                fallbackSrc={proofFallback}
                            />
                        ))}
                    </div>
                </>
            )}
        </>)}
                    {[28, 29, 30, 31, 32].includes(assignment?.assTypeId) && (<>
                        {/* Фото из БД */}
                        {photo1 && (
                            <>
                                <h6 className="text-muted mt-3 me-2">Uploaded confirmation file:</h6>
                                <div
                                    className="mt-2 mb-2"
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: proofUrls.length > 1 ? "repeat(2, minmax(0, 1fr))" : "minmax(0, 50%)",
                                        justifyContent: "start",
                                        gap: 12,
                                        width: "100%",
                                    }}
                                >
                                    {proofUrls.map((url, idx) => (
                                        <ProofImageCard
                                            key={`proof-${idx}`}
                                            src={url}
                                            alt={`Proof ${idx + 1}`}
                                            fallbackSrc={proofFallback}
                                        />
                                    ))}
                                </div>
                            </>
                        )}
                    </>)}

                    {/* 🔹 Message to Reviewer */}
                    {assignment?.comment_to_review && (
                        <Row className="d-flex justify-content-center mt-3">
                            <Col md={12} className="p-0 text-start">
                                <div className="card border border-secondary   rounded">
                                    <div className="card-header py-1 fw-semibold">
                                        Message You Sent to the Reviewer:
                                    </div>
                                    <div className="card-body p-3">
                                        <p className="mb-0 text-dark" style={{ lineHeight: "1.4" }}>
                                            {assignment.comment_to_review}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}

                </div>
                <Row className="d-flex justify-content-center mt-0 ms-3 me-3 mb-3 g-1 border-secondary">

                    <SimpleLogsViewerBA
                        userId={assignment?.userId}
                        type="assignment"
                        targetId={assignment?.id}
                        width="400px"
                    />


                </Row>


                <div className="position-absolute bottom-0 start-0 mb-2 ms-4 d-flex align-items-center">
                    {[...Array(5)].map((_, index) => (
                        <i
                            key={index}
                            className={`bi bi-star${index < a?.rating ? '-fill' : ''}`}
                            style={{
                                color: index < a?.rating ? 'gold' : 'lightgray',
                                fontSize: '18px',
                                marginRight: '5px'
                            }}
                        ></i>
                    ))} <span className="text-muted fs-6"> {assignment.rating
                    ? `${assignment.rating}.0`
                    : 'Not Applicable'}</span>
                </div>

                <div
                    className="modal-footer d-flex align-items-center justify-content-end px-2"
                    style={{ height: 44, paddingTop: 0, paddingBottom: 0 }}
                >
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={() => {
                            setError("");
                            handleClose();
                            if (typeof onClosed === "function") onClosed();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                </div>
            </div>
            <ImageLightbox
                src={fullImage}
                alt="Full size proof image"
                onClose={() => setFullImage(null)}
            />
        </Modal>
    );
};

export default InfoAssUnderBookS4;
